import { useAuthContext } from "../auth/AuthContext";

/**
 * Returns a unified logout function used by all logout entry points.
 *
 * Clears the local MSAL token cache without opening an Azure AD popup or
 * redirect. The Azure AD SSO session remains active so users can re-authenticate
 * silently on next visit, which is standard behaviour for enterprise SSO apps.
 */
export function useLogout(): () => Promise<void> {
    const { forceLogout } = useAuthContext();
    return forceLogout;
}
